import 'es6-promise/auto';

import * as queries from './queries';

const
    // SF_ACCESS_TOKEN = '2ce2591bd771176b5827baaa4f5b4b43',
    // SF_ACCESS_TOKEN = '3c7650f5f7de70c2ae7a89739b099a0e',

    SF_ENDPOINT = '/api/2022-07/graphql',
    SF_ACCESS_TOKEN_HEADER = 'X-Shopify-Storefront-Access-Token',

    ADMIN_ENDPOINT = '/admin/api/2023-07/graphql.json',

    AJAX_API_ROOT = `/`;

export class ShopifyApi {
    constructor() {
        this.adminApiKey = null;
        this.adminApiPassword = null;
    }

    getAccessToken() {
        switch (ABV4_SETTINGS.script_site_location) {
            case 'au':
                return "9f843f5411b72383ed4507a944a6cf0d";
            case 'us':
                return 'b14254a4add827997e82ecbd0a4c82b2';
            case 'wholesale':
                return "001b083e2efee25e3e7b9688e350016c";
            case 'abgdevus':
                return "65e43cf13fd9c7b0efc719f1b5d69035";
            default:
                return '3c7650f5f7de70c2ae7a89739b099a0e';
        }
    }

    setAdminCredentials(key, password) {
        this.adminApiKey = key || null;
        this.adminApiPassword = password || null;
    }

    ajaxEndpointUrl(path) {
        return AJAX_API_ROOT + path;
    }

    ajaxGet(path, params = {}) {
        const url = this.ajaxEndpointUrl(path);
        return new Promise((resolve, reject) => {
            jQuery.ajax({
                url,
                type: 'GET',
                dataType: 'json',
                data: params
            }).done((response) => {
                resolve(response);
            }).fail((xhr, status, errorThrown) => {
                reject(errorThrown);
            });
        });
    }

    ajaxPost(path, data) {
        const url = this.ajaxEndpointUrl(path);
        return new Promise((resolve, reject) => {
            jQuery.ajax({
                url,
                type: 'POST',
                dataType: 'text',
                data
            }).done((response) => {
                /* The cart/add.js endpoint sometimes returns bad JSON that
                 * causes requests to fail due to parser errors. */
                let responseData;
                try {
                    responseData = JSON.parse(response);
                } catch (e) {
                    responseData = null;
                }

                resolve(responseData);

            }).fail((xhr, error) => {
                reject(error);
            });
        });
    }

    storefrontQuery(query, variables = {}) {
        const SF_ACCESS_TOKEN = this.getAccessToken();
        return new Promise((resolve, reject) => {
            jQuery.ajax({
                url: SF_ENDPOINT,
                headers: {[SF_ACCESS_TOKEN_HEADER]: SF_ACCESS_TOKEN},
                type: 'POST',
                contentType: 'application/graphql',
                dataType: 'json',
                data: query
            }).done((response) => {
                if (response.data)
                    resolve(response.data);
                else
                    reject(response.errors);
            }).fail((xhr, error) => {
                reject(error);
            });
        });
    }

    adminQuery(query, variables = {}) {
        if (!this.adminApiKey || !this.adminApiPassword)
            return Promise.reject('No Admin API credentials set.');

        return new Promise((resolve, reject) => {
            jQuery.ajax({
                url: ADMIN_ENDPOINT,
                type: 'POST',
                contentType: 'application/graphql',
                dataType: 'json',
                data: {query, variables},
                username: this.adminApiKey,
                password: this.adminApiPassword
            }).done((response) => {
                if (response.data)
                    resolve(response.data);
                else
                    reject(response.errors);
            }).fail((xhr, error) => {
                reject(error);
            });
        });
    }

    productByHandle(handle, fieldSpec = {ajax: {}}) {
        let ajax = null, storefront = null;
        if (fieldSpec.ajax)
            ajax = this.ajaxGet(`products/${handle}.js`);
        
        if (fieldSpec.basic || fieldSpec.images || fieldSpec.variants || fieldSpec.collections)
            storefront = this.productByHandleStorefront(handle, fieldSpec);
        return Promise.all([ajax, storefront])
            .then(([ajax, storefront]) => ({ajax, storefront}));
    }

    productByHandleStorefront(handle, fieldSpec) {
        const query = queries.productByHandle(handle, fieldSpec);
        return this.storefrontQuery(query)
            .then((response) => {
                response.product
            });
    }

    cart() {
        return this.ajaxGet('cart.js');
    }

    cartUpdate(data) {
        return this.ajaxPost('cart/update.js', data);
    }

    cartChange(data) {
        return this.ajaxPost('cart/change.js', data);
    }

    addToCart(itemData) {
        return this.ajaxPost('cart/add.js', itemData);
    }

    exposeProductMetafield(namespace, key) {
        const variables = {
            input: {namespace, key, ownerType: 'PRODUCT'}
        };
        return this
            .adminQuery(
                `mutation($input: MetafieldStorefrontVisibilityInput!) {
                    metafieldStorefrontVisibility { id }
                    userErrors { field, message }
                }`, variables)
            .then((response) => {
                console.log('metafield exposed successfully: ', response);
            })
            .catch((error) => {
                console.log('metafield expose failed: ', error);
            });
    }


}
